module.exports = __webpack_public_path__ + "about-us-b998e096/imprint-271a5369587f923cf559794e13ea4228.svg";